import { Component } from '@angular/core';
import { StudentExamsService } from '../../../services/exams/student-exams.service';
import { jwtDecode } from 'jwt-decode';
import { CommonModule } from '@angular/common';
import { ExamRegisteredStudentsRegularModel } from '../../../models/exams/examination-models';

export interface SectionStats {
  sectionName: string;
  totalStudents: number;
  eligibleStudents: number;
  hncEligibleStudents: number;
  brcEligibleStudents: number;
  notEligibleStudents: number;
  hncNotEligibleStudents: number;
  brcNotEligibleStudents: number;
  eafRegistered: number;
  eafNotRegistered: number;
  hncRegistered: number;
  brcRegistered: number;
  hncNotRegistered: number;
  brcNotRegistered: number;
  notEligibleAndNotRegistered: number;
  hncNotEligibleAndNotRegistered: number;
  brcNotEligibleAndNotRegistered: number;
}

export interface YearSemStats {
  year: number;
  semester: string;
  yearSemLabel: string;
  sections: SectionStats[];
}

@Component({
  selector: 'app-exam-register-students-regular',
  imports: [CommonModule],
  templateUrl: './exam-register-students-regular.component.html',
  styleUrl: './exam-register-students-regular.component.css'
})
export class ExamRegisterStudentsRegularComponent {

  allStudentsRegular: ExamRegisteredStudentsRegularModel[] = [];
  allSections: string[] = [];
  matrixStats: YearSemStats[] = [];
  academicYearName: string = '';
  showModal: boolean = false;
  modalTitle: string = '';
  selectedStudents: ExamRegisteredStudentsRegularModel[] = [];
  modalCategory: string = '';
  hasHonoursData: boolean = true;
  hasBrcData: boolean = true;
  grandTotals: SectionStats = {
      sectionName: 'Total',
      totalStudents: 0,
      eligibleStudents: 0,
      hncEligibleStudents: 0,
      brcEligibleStudents: 0,
      notEligibleStudents: 0,
      hncNotEligibleStudents: 0,
      brcNotEligibleStudents: 0,
      eafRegistered: 0,
      eafNotRegistered: 0,
      hncRegistered: 0,
      brcRegistered: 0,
      hncNotRegistered: 0,
      brcNotRegistered: 0,
      notEligibleAndNotRegistered: 0,
      hncNotEligibleAndNotRegistered: 0,
      brcNotEligibleAndNotRegistered: 0
  };

  constructor(private examService: StudentExamsService) {}

  ngOnInit(){
    this.fetchExamRegisteredStudentsRegular();
  }

  fetchExamRegisteredStudentsRegular(){
        const token = localStorage.getItem('authToken');
        if(!token){
          // this.router.navigate(['/login']);
          return;
        }
        const decodedToken = jwtDecode(token) as {branchId: number};
        const branchId = decodedToken.branchId;
    
        const br = branchId.toString();
        this.examService.examRegisterStudentsRegularList(br).subscribe({
          next: (resp: any)=>{
            console.log("data is:",resp);
            if (resp) {
              console.table("students eaf regular data:",resp);
              this.allStudentsRegular = resp;
              this.academicYearName = resp[0].academicYear;
              this.processData();
            }
          },
          error: (error)=>{
            console.error("error fetching data",error);
          }
        })
  }
  processData(){
    this.grandTotals = {
      sectionName: 'Total',
      totalStudents: 0,
      eligibleStudents: 0,
      hncEligibleStudents: 0,
      brcEligibleStudents: 0,
      notEligibleStudents: 0,
      hncNotEligibleStudents: 0,
      brcNotEligibleStudents: 0,
      eafRegistered: 0,
      eafNotRegistered: 0,
      hncRegistered: 0,
      brcRegistered: 0,
      hncNotRegistered: 0,
      brcNotRegistered: 0,
      notEligibleAndNotRegistered: 0,
      hncNotEligibleAndNotRegistered: 0,
      brcNotEligibleAndNotRegistered: 0
    };

    const sectionSet = new Set<string>();
    const yearSemSet = new Set<string>();

    this.allStudentsRegular.forEach(s=>{
      if(s.section){
        sectionSet.add(s.section);
      }
      if (s.year && s.semester) {
        yearSemSet.add(s.year + '|' + s.semester);
      }
    });

    this.allSections = Array.from(sectionSet).sort();
    const uniqueYearSems = Array.from(yearSemSet).sort(); // Basic sort, e.g. "1|1", "1|2", "2|1"...

    this.matrixStats = uniqueYearSems.map(ys => {
      const [yearStr, semStr] = ys.split('|');
      const year = parseInt(yearStr, 10);
      
      const yearSemLabel = this.getYearSemLabel(year, semStr);
      
      const studentsInYearSem = this.allStudentsRegular.filter(s => s.year === year && s.semester === semStr);
      
      const sections: SectionStats[] = [];

      this.allSections.forEach(section => {
        const studentsInSection = studentsInYearSem.filter(s => s.section === section);
        const totalStudents = studentsInSection.length;
        
        if (totalStudents === 0) return; // Skip empty sections for this Year/Sem

        // Note: modify if business logic differs
        const eligibleStudents = studentsInSection.filter(s => s.paymentStatusReg !== 'NotElg').length;
        const hncEligibleStudents = studentsInSection.filter(s => s.honoursEafElgCheck === 'HncElg').length;
        const brcEligibleStudents = studentsInSection.filter(s => s.brcEafElgCheck === 'BrcElg').length;
        // console.log("brc Eligible students",brcEligibleStudents);

        const notEligibleStudents = totalStudents - eligibleStudents;
        const hncNotEligibleStudents = studentsInSection.filter(s => s.honoursEafElgCheck === 'HncNotElg').length;
        const brcNotEligibleStudents = studentsInSection.filter(s => s.brcEafElgCheck === 'BrcNotElg').length;

        const eafRegistered = studentsInSection.filter(s => ['success'].includes(s.paymentStatusReg)).length;
        const eafNotRegistered = eligibleStudents - eafRegistered;

        const hncRegistered = studentsInSection.filter(s => s.paymentStatusHnc === 'success').length;
        const brcRegistered = studentsInSection.filter(s => s.paymentStatusBrc === 'success').length;

        const hncNotRegistered = hncEligibleStudents - hncRegistered;//studentsInSection.filter(s => s.paymentStatusHnc === 'HncNotPaid').length;
        const brcNotRegistered = brcEligibleStudents - brcRegistered;//studentsInSection.filter(s => s.paymentStatusBrc === 'BrcNotPaid').length; 

        const notEligibleAndNotRegistered = notEligibleStudents + eafNotRegistered;  //studentsInSection.filter(s => s.paymentStatusReg === 'NotElg').length;
        const hncNotEligibleAndNotRegistered = hncNotRegistered  //studentsInSection.filter(s => s.paymentStatusReg === 'NotElg').length;
        const brcNotEligibleAndNotRegistered = brcNotRegistered   //studentsInSection.filter(s => s.paymentStatusReg === 'NotElg').length;  

        this.grandTotals.totalStudents += totalStudents;
        this.grandTotals.eligibleStudents += eligibleStudents;
        this.grandTotals.hncEligibleStudents += hncEligibleStudents;
        this.grandTotals.brcEligibleStudents += brcEligibleStudents;
        this.grandTotals.notEligibleStudents += notEligibleStudents;
        this.grandTotals.hncNotEligibleStudents += hncNotEligibleStudents;
        this.grandTotals.brcNotEligibleStudents += brcNotEligibleStudents;
        this.grandTotals.eafRegistered += eafRegistered;
        this.grandTotals.hncRegistered += hncRegistered;
        this.grandTotals.brcRegistered += brcRegistered;
        this.grandTotals.hncNotRegistered += hncNotRegistered;
        this.grandTotals.brcNotRegistered += brcNotRegistered;
        this.grandTotals.eafNotRegistered += eafNotRegistered;
        this.grandTotals.notEligibleAndNotRegistered += notEligibleAndNotRegistered;
        this.grandTotals.hncNotEligibleAndNotRegistered += hncNotEligibleAndNotRegistered;
        this.grandTotals.brcNotEligibleAndNotRegistered += brcNotEligibleAndNotRegistered;

        sections.push({
          sectionName: section,
          totalStudents,
          eligibleStudents,
          hncEligibleStudents,
          brcEligibleStudents,
          notEligibleStudents,
          hncNotEligibleStudents,
          brcNotEligibleStudents,
          eafRegistered,
          hncRegistered,
          brcRegistered,
          hncNotRegistered,
          brcNotRegistered, 
          eafNotRegistered,
          notEligibleAndNotRegistered,
          hncNotEligibleAndNotRegistered,
          brcNotEligibleAndNotRegistered
        });
      });

      return {
        year,
        semester: semStr,
        yearSemLabel,
        sections
      };
    }).filter(ys => ys.sections.length > 0);

  }

  getYearSemLabel(year: number, semester: string): string {
    const yearMapping: Record<number, string> = { 1: 'First', 2: 'Second', 3: 'Third', 4: 'Fourth', 5: 'Fifth', 6: 'Sixth' };
    const semMapping: Record<string, string> = { '1': 'I', '2': 'II', '3': 'III', '4': 'IV', '5': 'V', '6': 'VI', '7': 'VII', '8': 'VIII' };
    
    // Check if the user wants exactly "second year and semester"
    // They asked for: "second year and semester", "third year and semester", etc.
    const yearStr = yearMapping[year] || `${year}th`;
    const semStrDisplay = semMapping[semester] || semester;
    return `${yearStr} Year - ${semStrDisplay} Semester`;
  }

  openModal(year: number, semester: string, section: string, category: string) {
    this.modalCategory = category;
    let studentsInSection = [];
    if (year === 0 && semester === 'All' && section === 'All') {
      studentsInSection = this.allStudentsRegular;
    } else {
      studentsInSection = this.allStudentsRegular.filter(s => s.year === year && s.semester === semester && s.section === section);
    }
    let list: ExamRegisteredStudentsRegularModel[] = [];

    const eligibleStudents = studentsInSection.filter(s => s.paymentStatusReg !== 'NotElg');
    const hncEligibleStudents = studentsInSection.filter(s => s.honoursEafElgCheck === 'HncElg');
    const brcEligibleStudents = studentsInSection.filter(s => s.brcEafElgCheck === 'BrcElg');

    switch (category) {
      case 'Total':
        list = studentsInSection;
        break;
      case 'Eligible':
        list = studentsInSection.filter(s => s.paymentStatusReg !== 'NotElg' || s.honoursEafElgCheck === 'HncElg' || s.brcEafElgCheck === 'BrcElg');
        break;
      case 'Not Eligible':
        list = studentsInSection.filter(s => s.paymentStatusReg === 'NotElg');
        break;
      case 'EAF Registered':
        list = studentsInSection.filter(s => ['success'].includes(s.paymentStatusReg) || s.paymentStatusHnc === 'success' || s.paymentStatusBrc === 'success');
        break;
      case 'EAF Not Registered':
        list = studentsInSection.filter(s => 
          (s.paymentStatusReg !== 'NotElg' && !['success'].includes(s.paymentStatusReg)) ||
          (s.honoursEafElgCheck === 'HncElg' && s.paymentStatusHnc !== 'success') ||
          (s.brcEafElgCheck === 'BrcElg' && s.paymentStatusBrc !== 'success')
        );
        break;
      case 'Not Eligible & Not Registered':
        list = studentsInSection.filter(s => 
          s.paymentStatusReg === 'NotElg' ||
          (s.paymentStatusReg !== 'NotElg' && !['success'].includes(s.paymentStatusReg)) ||
          (s.honoursEafElgCheck === 'HncElg' && s.paymentStatusHnc !== 'success') ||
          (s.brcEafElgCheck === 'BrcElg' && s.paymentStatusBrc !== 'success')
        );
        break;
    }

    this.selectedStudents = list;
    
    this.hasHonoursData = this.selectedStudents.some(s => !!this.getHonoursStatus(s, category));

    this.hasBrcData = this.selectedStudents.some(s => !!this.getBrcStatus(s, category));
    
    if (year === 0 && semester === 'All' && section === 'All') {
      this.modalTitle = `Grand Total - ${category}`;
    } else {
      this.modalTitle = `${year} Year - ${semester} Semester | Sec ${section} - ${category}`;
    }
    this.showModal = true;
  }

  getRegularStatus(s: ExamRegisteredStudentsRegularModel, category: string): string {
    return s.paymentStatusReg || '';
  }

  getHonoursStatus(s: ExamRegisteredStudentsRegularModel, category: string): string {
    const val = (category === 'Eligible' || category === 'Not Eligible') ? s.honoursEafElgCheck : s.paymentStatusHnc;
    return val === 'NonHnc' ? '' : (val || '');
  }

  getBrcStatus(s: ExamRegisteredStudentsRegularModel, category: string): string {
    const val = (category === 'Eligible' || category === 'Not Eligible') ? s.brcEafElgCheck : s.paymentStatusBrc;
    return val === 'NonBrc' ? '' : (val || '');
  }

  closeModal() {
    this.showModal = false;
  }

}
